import React, { useCallback } from 'react';
import LoadingIndicator from '../../LoadingIndicator';
import StreamedList from '../../StreamedList';
import GallectionListItem from '../../GallectionListItem';
import s from './CollectionList.scss';
var CollectionsList = function (_a) {
    var collectibleDeviation = _a.collectibleDeviation, selectedFolderIds = _a.selectedFolderIds, collections = _a.collections, filterValue = _a.filterValue, headerContent = _a.headerContent, isFetching = _a.isFetching, streamId = _a.streamId, isInitialized = _a.isInitialized, toggleCollectionProp = _a.toggleCollection;
    var toggleCollection = useCallback(function (_a) {
        var folderId = _a.folderId;
        toggleCollectionProp(folderId, collectibleDeviation.deviationId);
    }, [collectibleDeviation.deviationId, toggleCollectionProp]);
    return (React.createElement(React.Fragment, null,
        headerContent,
        React.createElement(StreamedList, { streamId: streamId, className: s['list'], wrapperClassName: s['scrollable'], skipInitialFetch: true },
            collections.map(function (collection) {
                return collection &&
                    (!filterValue ||
                        collection.name
                            .toLowerCase()
                            .includes(filterValue.toLowerCase())) ? (React.createElement(GallectionListItem, { control: "checkbox", isSelected: selectedFolderIds &&
                        selectedFolderIds.includes(collection.folderId), gallection: collection, onChange: toggleCollection })) : null;
            }),
            (!isInitialized || isFetching) && (React.createElement(LoadingIndicator, { view: "llama", className: s['loader'] })))));
};
export default CollectionsList;
//# sourceMappingURL=CollectionList.js.map